<template>
  <v-dialog
    v-model="dialogState"
    width="500"
  >
    <v-card>
      <v-app-bar
        color="cyan"
        dark
        flat
      >
        <v-toolbar-title
          class="font-weight-light text-uppercase"
        >
          <v-icon
            left
          >
            mdi-human-greeting
          </v-icon>
          Welcome back {{ userFullName }}
        </v-toolbar-title>
      </v-app-bar>

      <v-card-text
        class="pa-3 pb-6"
      >
        <v-container
          class="pa-0"
          fluid
        >
          <v-row>
            <v-col>
              <v-alert
                class="mb-0"
                icon="mdi-alert-rhombus"
                outlined
                text
                type="warning"
              >
                Your IP Address changed since your last login.
              </v-alert>
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="text-right"
              cols="2"
            >
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </template>
                <span>Last Login Date</span>
              </v-tooltip>
            </v-col>
            <v-col>
              {{ getLastLoginDate }}
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="text-right"
              cols="2"
            >
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-wan
                  </v-icon>
                </template>
                <span>IP Address / Hostname</span>
              </v-tooltip>
            </v-col>
            <v-col>
              {{ getLastLoginIPAndHost }}
            </v-col>
          </v-row>

          <v-row>
            <v-col
              class="text-right"
              cols="2"
            >
              <v-tooltip bottom>
                <template #activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-map-marker-outline
                  </v-icon>
                </template>
                <span>Last Logged In from</span>
              </v-tooltip>
            </v-col>
            <v-col>
              {{ getLastLoginLocation }}
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-divider />

      <v-card-actions>
        <v-spacer />

        <v-btn
          color="primary"
          @click="dialogState = false"
        >
          Ok
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import { AUTHENTICATION_NAMESPACE } from '@/store/authentication'

export default {
  name: 'LastLoginInfoDialog',

  computed: {
    dialogState: {
      get () {
        return this.getLastLoginInfoDialogState
      },

      set (val) {
        if (val || val === this.getLastLoginInfoDialogState) return
        this.hideLastLoginInfoDialog()
      },
    },

    userFullName () {
      return `${this.getCurrentUser.display_name}`
    },

    ...mapGetters([
      'getCurrentUser',
    ]),

    ...mapGetters(AUTHENTICATION_NAMESPACE, [
      'getLastLoginDate',
      'getLastLoginIPAndHost',
      'getLastLoginInfoDialogState',
      'getLastLoginLocation',
    ]),
  },

  methods: {
    ...mapActions(AUTHENTICATION_NAMESPACE, [
      'hideLastLoginInfoDialog',
    ]),
  },
}
</script>
